<template>
  <div class="download">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="download-main">
        <div class="phone-img"></div>
        <div class="download-content">
          <div class="download-title">聚师傅服务商端、师傅端APP</div>
          <div class="download-tips">让家居服务变得轻松、便捷</div>
          <div class="download-code">
            <div class="download-code-left">
              <!-- <img src="../../assets/img/ewm.png" alt /> -->
              <canvas id="canvas"></canvas>
              <span>扫描下载客户端</span>
            </div>
            <div class="download-code-right">
              <a
                href="https://apps.apple.com/cn/app/%E8%81%9A%E5%B8%88%E5%82%85/id1506700998"
                target="_blank"
                rel="noopener noreferrer"
              >
                <el-button class="download-app">IOS下载</el-button>
              </a>
              <a
                :href="androidUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <el-button class="download-app">安卓下载</el-button></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
import QRCode from "qrcode";
export default {
  components: {
    headTop,
    QRCode
  },
  data() {
    return {
      androidUrl:process.env.VUE_APP_ANDROID_URL,
    };
  },
  mounted() {
    this.urlCode();
  },
  methods: {
    urlCode() {
      var canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, process.env.VUE_APP_MOBILE + "/download");
    }
  }
};
</script>
<style lang="scss">
.download {
  #canvas {
    width: 140px !important;
    height: 140px !important;
  }
  #nav {
    height: 748px;
    background: url("../../assets/img/pg.jpg") no-repeat;
    background-position: center;
    background-size: cover;
    .download-main {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 286px 0 103px;
      .phone-img {
        background: url("../../assets/img/iphone_pic.png") no-repeat;
        background-size: cover;
        width: 392px;
        height: 488px;
        margin-top: 151px;
      }
      .download-content {
        height: 280px;
        width: 308px;
        margin-top: 226px;
        .download-title {
          width: 262px;
          font-size: 20px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 1;
        }
        .download-tips {
          height: 14px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          line-height: 1;
          margin-top: 17px;
        }
        .download-code {
          margin-top: 60px;
          display: flex;
          justify-content: space-between;
          .download-code-left {
            display: flex;
            flex-direction: column;
            background: #ffffff;
            width: 140px;
            height: 168px;
            align-items: center;
            justify-content: space-between;
            span {
              margin-bottom: 12px;
              font-size: 12px;
              height: 12px;
              line-height: 1;
            }
          }
          .download-code-right {
            width: 140px;
            margin-top: 68px;
            .download-app {
              width: 140px;
              height: 34px;
              border: 1px solid rgba(255, 255, 255, 1);
              border-radius: 0;
              margin-left: 0;
              background: transparent;
              color: #ffffff;
              padding: 0;
              font-size: 12px;
              margin-top: 16px;
            }
          }
        }
      }
    }
  }
  .download_tab {
    border-bottom: 2px solid #ffffff;
  }
}
</style>
